import { render, staticRenderFns } from "./SelectSublocationCard.vue?vue&type=template&id=e96aebc4&"
import script from "./SelectSublocationCard.vue?vue&type=script&lang=js&"
export * from "./SelectSublocationCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports